export default __webpack_public_path__ + "static/media/Testes-Software-PT.c1186a2e.jpg";